/**
 * @param {array} lazyElements - array of elements to watch.
 * @param {function} lazyCallback(entry, observer) - callback function to trigger when element is in the viewport.
 * @param {float} threshold -  percent in decimals that object should be in view for the callback to trigger.
 */

export default function lazyElements(lazyElements, lazyCallback, threshold = 0) {

    const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                observer.unobserve(entry.target);
                lazyCallback(entry, observer);
            }
        });
    }, {
        threshold: threshold,
    });


    /**
     * Snippet on next like checks to see if lazyElements can be iterated over.
     * lazyElements[Symbol.iterator] === 'function')
     */

    if (lazyElements instanceof NodeList || Array.isArray(lazyElements)) {
        lazyElements.forEach(element => {
            observer.observe(element);
        });
    } else {
        observer.observe(lazyElements);
    }

    observer.observe;

    return observer;
}
